import { Module } from 'vuex'
import { StateInterface } from '@/store'

import { Dark } from 'quasar'

export interface DrawerModel {
  opened: boolean;
  withoutAnimation: boolean;
}

export interface AppState {
  drawer: null | DrawerModel,
  fullscreen: false,
  hideMobileNav: false,
  hideFilters: false
}

const AppModule: Module<AppState, StateInterface> = {
  namespaced: true,
  state: {
    drawer: {
      opened: true,
      withoutAnimation: false
    },
    fullscreen: false,
    hideMobileNav: false,
    hideFilters: false
  },
  mutations: {
    SetFullscreen: (state: AppState, value) => {
      state.fullscreen = value
    },
    HideFilters: (state: AppState, value) => {
      state.hideFilters = value
    },
    HideMobileNav: (state: AppState, value) => {
      state.hideMobileNav = value
    },
    SetDrawer: (state: AppState, drawer: DrawerModel) => {
      state.drawer = drawer
    },
    ToggleDrawer: (state: AppState, force: boolean) => {
      if (state.drawer) {
        state.drawer.opened = typeof force === 'boolean' ? force : !state.drawer.opened
      }
    },
    SetDarkMode: (state: AppState, val: boolean) => {
      Dark.set(val)
    },
    ToggleDarkMode: (state: AppState) => {
      Dark.toggle()
    }
  },
  getters: {
    Drawer: state => state.drawer,
    DrawerOpened: state => (state.drawer && state.drawer.opened),
    DarkMode: state => Dark.isActive,
    IsFullscreen: state => state.fullscreen,
    HideMobileNav: state => state.hideMobileNav,
    HideFilters: state => state.hideFilters
  }
}

export default AppModule
